export default "__VITE_ASSET__DF8SgBWT__"